// Mobile menu
import {gsap} from "gsap";

const menuBtn = document.querySelector('.menu-btn');
const menuBtnText = document.querySelector('.menu-btn-text');
const mobileNav = document.querySelector('.mobile-nav');
const menuOverlay = document.querySelector('.menu-overlay');
const menuOpen = document.querySelector('.menu-open');
const menuClose = document.querySelector('.menu-close');
const menuItems = mobileNav.querySelectorAll('ul > li');

let isOpen = false;

const tl = gsap.timeline({paused: true, defaults: {duration: 0.6, ease: "power2.out"}});

tl.set([mobileNav, menuOverlay], {
    display: 'block',
    visibility: 'visible'
})
        .to(menuOverlay, {
            opacity: .9,
            duration: 0.2,
            pointerEvents: 'auto',
            ease: "Expo.easeInOut",
        }, 0)
        .to(mobileNav, {
            opacity: 1,
            scale: 1
        }, 0)
        .from(menuItems, {
            x: -10,
            opacity: 0,
            stagger: 0.07
        }, "-=0.3");

function openMenu() {
    tl.play(0);

    gsap.to(menuBtnText, {
        opacity: 0,
        scale: 0.8,
        duration: 0.2,
        onComplete: () => {
            menuBtnText.textContent = 'Sluiten';
            gsap.to(menuBtnText, {
                opacity: 1,
                scale: 1,
                duration: 0.3,
            });
        }
    });
    gsap.to(menuClose, {
        opacity: 0,
        scale: 0.8,
        duration: 0.2,
        onComplete: () => {
            gsap.to(menuClose, {
                opacity: 1,
                scale: 1,
                duration: 0.3,
            });
        }
    });
    gsap.to(menuOpen, {
        opacity: 1,
        scale: 1,
        duration: 0.2,
        onComplete: () => {
            gsap.to(menuOpen, {
                opacity: 0,
                scale: 0.8,
                duration: 0.3,
            });
        }
    });

    isOpen = true;
}

function closeMenu() {
    gsap.to(menuItems, {
        opacity: 0,
        x: -10,
        stagger: -0.05,
        duration: 0.3,
        ease: "power2.in"
    });

    gsap.to(mobileNav, {
        opacity: 0,
        scale: .9,
        duration: 0.2,
        ease: "power3.in",
        onComplete: () => {
            mobileNav.style.visibility = 'hidden';
        }
    });

    gsap.to(menuOverlay, {
        opacity: 0,
        duration: 0.3, ease: "Expo.easeInOut",
        onComplete: () => {
            menuOverlay.style.visibility = 'hidden';
        }
    });

    gsap.to(menuBtnText, {
        opacity: 0,
        scale: 0.8,
        duration: 0.2,
        onComplete: () => {
            menuBtnText.textContent = 'Menu';
            gsap.to(menuBtnText, {
                opacity: 1,
                scale: 1,
                duration: 0.3,
                ease: "power2.out"
            });
        }
    });
    gsap.to(menuClose, {
        opacity: 1,
        scale: 1,
        duration: 0.2,
        onComplete: () => {
            gsap.to(menuClose, {
                opacity: 0,
                scale: 0.8,
                duration: 0.3,
            });
        }
    });
    gsap.to(menuOpen, {
        opacity: 0,
        scale: 0.8,
        duration: 0.2,
        onComplete: () => {
            gsap.to(menuOpen, {
                opacity: 1,
                scale: 1,
                duration: 0.3,
            });
        }
    });

    isOpen = false;
}

menuBtn.addEventListener('click', () => {
    isOpen ? closeMenu() : openMenu();
});
menuOverlay.addEventListener('click', () => {
    if (isOpen) closeMenu();
});
